// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2lm2T","mask":"index-mask-Mz7-Q","messageContent":"index-messageContent-3IXcp","fadeIn":"index-fadeIn-2iHf7","fadeOut":"index-fadeOut-3nnre"};